"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAPIUrl = exports.getAPIPort = void 0;
var url_1 = require("url");
var window_1 = require("./window");
function removeTrailingSlashes(path) {
    return path.replace(/[/]+$/, '');
}
var getAPIPort = function (_a) {
    var host = _a.host, testingPortMappings = _a.testingPortMappings;
    var port = host.split(':')[1];
    var apiPort = testingPortMappings.find(function (_a) {
        var uiPort = _a.uiPort;
        return uiPort === parseInt(port, 10);
    }).apiPort;
    return apiPort;
};
exports.getAPIPort = getAPIPort;
function isUrlObject(urlObject) {
    return typeof urlObject !== 'string';
}
var getAPIUrl = function (_a) {
    var service = _a.service, context = _a.context, pathname = _a.pathname, query = _a.query, parallelTest = _a.parallelTest, testingPortMappings = _a.testingPortMappings;
    if (isUrlObject(service.uri)) {
        var apiPathname = "".concat(service.uri.pathname || '').concat(pathname);
        if (parallelTest && !(0, window_1.isClient)()) {
            return (0, url_1.format)(__assign(__assign({}, service.uri), { port: (0, exports.getAPIPort)({ testingPortMappings: testingPortMappings, host: context.host }), pathname: apiPathname, query: query }));
        }
        return (0, url_1.format)(__assign(__assign({}, service.uri), { pathname: apiPathname, query: query }));
    }
    return (0, url_1.format)({
        host: removeTrailingSlashes(service.uri),
        pathname: pathname,
        query: query
    });
};
exports.getAPIUrl = getAPIUrl;
